<template>
    <button
        v-tippy="t('editorDeleteColumn')"
        :class="[buttonState(editor.can().deleteColumn()), 'flex-none rounded p-1 text-sm']"
        :disabled="!editor.can().deleteColumn()"
        @click="editor.chain().focus().deleteColumn().run()"
    >
        <MdiTableColumnRemove class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiTableColumnRemove from 'materialdesignicons-vue3/icons/MdiTableColumnRemove.js';

    defineExpose({
        name: 'DeleteTableColumnButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
